import React from 'react';
import { Skeleton } from '@mui/material';
import styles from './WalletLoading.module.css';

/** Primeira carga: dois cartões de pacote e as movimentações em esqueleto. */
function WalletLoading() {
  return (
    <div className={styles.wrap} aria-busy="true" aria-label="Carregando pacotes">
      <div className={styles.grid}>
        {[0, 1].map((card) => (
          <div key={card} className={styles.card}>
            <div className={styles.cardHead}>
              <Skeleton variant="rounded" width={38} height={38} sx={{ borderRadius: '10px' }} />
              <div className={styles.cardText}>
                <Skeleton variant="text" width="55%" height={20} />
                <Skeleton variant="text" width="40%" height={16} />
              </div>
              <Skeleton variant="rounded" width={70} height={22} sx={{ borderRadius: '999px' }} />
            </div>
            {[0, 1, 2].map((row) => (
              <div key={row} className={styles.cardRow}>
                <div className={styles.cardRowTop}>
                  <Skeleton variant="text" width="45%" height={18} />
                  <Skeleton variant="text" width={80} height={16} />
                </div>
                <Skeleton variant="rounded" height={5} sx={{ borderRadius: '999px' }} />
              </div>
            ))}
          </div>
        ))}
      </div>

      <div className={styles.card}>
        <div className={styles.cardHead}>
          <Skeleton variant="text" width={110} height={22} />
        </div>
        {[0, 1, 2, 3].map((row) => (
          <div key={row} className={styles.historyRow}>
            <Skeleton variant="circular" width={32} height={32} />
            <div className={styles.cardText}>
              <Skeleton variant="text" width="50%" height={18} />
              <Skeleton variant="text" width="30%" height={14} />
            </div>
            <Skeleton variant="text" width={70} height={18} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default WalletLoading;
